import React, { FC } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { ActionButton, ActionButtonStatus } from "../actionButton/ActionButton";

interface LikeProp {
  readonly status: ActionButtonStatus;
  readonly onPress: () => void;
}

const Like: FC<LikeProp> = ({ status, onPress }) => {
  const likeText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.LIKE, prefix: PREFIX });

  return (
    <ActionButton
      alignment="right"
      icon="heart"
      status={status}
      testID="like-button"
      text={likeText}
      onPress={onPress}
    />
  );
};

export { Like };
